<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  name: 'FeedbackSubjectCreate',
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('feedback.subject.create')
  }),
  computed: {
    ...mapState('feedbackSubject', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('feedback.title'), to: { name: 'feedback.index' } },
      { text: vm.$t('feedback.subject.title'), to: { name: 'feedback.subject.index' } },
      { text: vm.$t('feedback.subject.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('feedbackSubject/clearItem')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('feedbackSubject', ['createItem', 'updateItem'])
  }
}
</script>
